/*!
 * clyro-dynamic-checkout.js - dynamic checkout helper for template-simple.
 *
 * Fixed infrastructure (like clyro-shop.js). No custom button colors: Shopify
 * styles Shop Pay / Buy it now (same as Dawn). This file only syncs variant id
 * on pick() and wires the mock payment_button in Clyro preview.
 */
(function () {
  function formFor(root) {
    return root.closest('form');
  }

  function syncVariant(root, variant) {
    var form = formFor(root);
    if (!form) return;
    var input = form.querySelector('input[name="id"]');
    var available = !!(variant && variant.id != null && variant.available !== false);
    if (input) {
      input.value = variant && variant.id != null ? String(variant.id) : '';
      input.disabled = !available;
    }
    // Shopify can render a closed shadow-root button. Hide/inert its wrapper
    // as well as disabling any accessible mock buttons.
    root.hidden = !available;
    root.inert = !available;
    root.querySelectorAll('.shopify-payment-button__button, .shopify-payment-button__button--unbranded').forEach(function (btn) {
      btn.disabled = !available;
    });
  }

  function wireMockBuyNow(root) {
    root.querySelectorAll('.shopify-payment-button__button--unbranded').forEach(function (btn) {
      if (btn.dataset.clyroBinWired) return;
      btn.dataset.clyroBinWired = '1';
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var form = formFor(root);
        if (!form) return;
        var idInput = form.querySelector('input[name="id"]');
        var qtyInput = form.querySelector('input[name="quantity"]');
        var vid = idInput && idInput.value;
        var qty = (qtyInput && Number(qtyInput.value)) || 1;
        if (!vid || !window.clyroShop || !window.clyroShop.add) return;
        btn.disabled = true;
        window.clyroShop.add(vid, qty).then(function () {
          window.location.href = '/checkout';
        }).catch(function () {
          btn.disabled = false;
        });
      });
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.clyroDynInit) return;
    root.dataset.clyroDynInit = '1';
    wireMockBuyNow(root);
    var form = formFor(root);
    if (form) {
      var owner = root.closest('[data-clyro-buybox]');
      var input = form.querySelector('input[name="id"]');
      syncVariant(root, owner ? owner.__clyroVariant : input && input.value && !input.disabled ? { id: input.value, available: true } : null);
    }
    try {
      var obs = new MutationObserver(function () { wireMockBuyNow(root); });
      obs.observe(root, { childList: true, subtree: true });
    } catch (_) {}
  }

  function initAll() {
    document.querySelectorAll('[data-dd]').forEach(initRoot);
  }

  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    var owner = e.target;
    if (!owner || !owner.hasAttribute || !owner.hasAttribute('data-clyro-buybox')) return;
    owner.querySelectorAll('[data-dd]').forEach(function (root) {
      if (root.closest('[data-clyro-buybox]') === owner) syncVariant(root, v);
    });
  });

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('alpine:initialized', initAll);
  initAll();

  window.clyroDynamicCheckout = { init: initAll, syncVariant: syncVariant };
})();
